// Hook pour le checkout d'un produit/service de boutique via Stripe Connect
import { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

function getToken() {
  return (
    localStorage.getItem('ecosystem_token') ||
    localStorage.getItem('social_token') ||
    localStorage.getItem('client_token') ||
    ''
  );
}

export function useBoutiqueCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function initiateCheckout({ sellerId, productName, amount, quantity = 1, productId = null }) {
    setLoading(true);
    setError(null);

    const token = getToken();
    const origin = window.location.origin;

    try {
      const res = await fetch(`${API_URL}/api/stripe-connect/checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          seller_id: sellerId,
          product_name: productName,
          amount,
          quantity,
          product_id: productId,
          origin_url: origin,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        const msg = data.detail || 'Erreur lors du paiement.';
        setError(msg);
        return { success: false, error: msg };
      }

      // Rediriger vers Stripe Checkout
      window.location.href = data.checkout_url;
      return { success: true, data };
    } catch (err) {
      const msg = 'Erreur de connexion au serveur.';
      setError(msg);
      return { success: false, error: msg };
    } finally {
      setLoading(false);
    }
  }

  return { initiateCheckout, loading, error, setError };
}
